__turbopack_context__.v({
  "className": "ofpbQW_className",
  "variable": "ofpbQW_variable",
});
